import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface IProductStockAvailability {
  labelProvider: labelProviderInterface;
  rtl: boolean;
  stockAvailability: string;
}

export const ProductStockAvailability: FunctionalComponent<
  IProductStockAvailability
> = (props) => {
    const { labelProvider, rtl, stockAvailability } = props;
    const onStock = stockAvailability || 0;
    return (
      <div class="result-card__stock-availability">
        <qds-tag
          size="standard"
          importance="subdued"
          color="green"
          status={onStock === 0 ? 'warning' : 'success'}
          icon={true}
          icon-name={onStock === 0 ? 'cross-circle' : 'check-circle'}
          text={onStock + ' ' + 'produit (s) en stock'}
          dir={rtl ? 'rtl' : 'ltr'}
        />
      </div>
    );

};
